import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyTitleComponent } from './survey-title.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';
// import {Autosize} from 'ng-autosize';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, 
    AutosizeModule,
    // Autosize,
  ],
  declarations: [SurveyTitleComponent],
  exports: [SurveyTitleComponent]
})
export class SurveyTitleModule {}
